module.exports = __webpack_public_path__ + "static/media/avatars.0ed9061f.jpg";